// extracted by mini-css-extract-plugin
module.exports = {"copy":"recipient-description_copy__1dBRZ"};